import React from "react";
import { Layout } from "../../components/Layout/Layout";
import HomeMain from "../../components/Home/HomeMain"; // Modificación en esta línea

const Home = () => {
  return (
    <>
      <Layout />
      <HomeMain />
    </>
  );
};

export default Home;
